import '../FreeroamHud.css'

export interface IFreeroamHudItem {
	icon: string
	text: string
	color: string
	updateAmount: string
	updateId: number
}

export const FreeroamHudItem = ({
	icon,
	text,
	color,
	updateAmount,
	updateId
}: IFreeroamHudItem) => {
	return (
		<div className='freeroam-hud-item-wrapper'>
			<div className='freeroam-hud-item' style={{ backgroundColor: color }}>
				<div className='freeroam-hud-item-icon'>
					<img src={`./icons/16px/${icon}.png`} alt={icon} />
				</div>

				<div className='freeroam-hud-item-text-wrapper'>
					<div className='freeroam-hud-item-text'>
						<p>{text}</p>
					</div>
				</div>
			</div>

			<div className='freeroam-hud-action-slot' style={{ display: updateAmount ? "flex" : "none" }}>
				<div key={updateId} className='freeroam-hud-action-item'>
					<p className='freeroam-hud-action-item-text'>{updateAmount}</p>
				</div>
			</div>
		</div>
	)
}